/**
 * This data is generated from
 * ****************************************************
 * DEVELOPERS NOTE: COPY from https://test-api.salaxy.com/docs/EnumJson/ir / http://localhost:82/docs/EnumJson/ir
 * DO NOT EDIT DIRECTLY
 * @ignore
 */
 export const generatedIrEnumData = [
  {
    "name": "ActionCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "newReport"
      },
      {
        "order": 2,
        "name": "replacementReport"
      }
    ]
  },
  {
    "name": "AddressType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "addressInHomeCountry"
      },
      {
        "order": 2,
        "name": "addressInTheCountryOfWork"
      }
    ]
  },
  {
    "name": "AgeGroupCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "a"
      },
      {
        "order": 2,
        "name": "b"
      },
      {
        "order": 3,
        "name": "c"
      },
      {
        "order": 4,
        "name": "u"
      }
    ]
  },
  {
    "name": "AllowanceCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "mealAllowance"
      },
      {
        "order": 2,
        "name": "partialDailyAllowance"
      },
      {
        "order": 3,
        "name": "fullDailyAllowance"
      },
      {
        "order": 4,
        "name": "internationalDailyAllowance"
      },
      {
        "order": 5,
        "name": "taxExemptReimbursementsAbroad"
      }
    ]
  },
  {
    "name": "ApiValidationErrorType",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "general"
      },
      {
        "order": 10,
        "name": "required"
      },
      {
        "order": 20,
        "name": "invalid"
      },
      {
        "order": 30,
        "name": "warning"
      }
    ]
  },
  {
    "name": "BenefitCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "accommodationBenefit"
      },
      {
        "order": 2,
        "name": "telephoneBenefit"
      },
      {
        "order": 3,
        "name": "mealBenefit"
      },
      {
        "order": 4,
        "name": "otherBenefits"
      }
    ]
  },
  {
    "name": "CalcGroup",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "undefined"
      },
      {
        "order": 1,
        "name": "baseSalary"
      },
      {
        "order": 2,
        "name": "salaryAdditions"
      },
      {
        "order": 3,
        "name": "benefits"
      },
      {
        "order": 4,
        "name": "expenses"
      },
      {
        "order": 5,
        "name": "deductions"
      },
      {
        "order": 6,
        "name": "otherNoPayment"
      },
      {
        "order": 100,
        "name": "totals"
      },
      {
        "order": 200,
        "name": "disabled"
      }
    ]
  },
  {
    "name": "CarBenefitCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "limitedCarBenefit"
      },
      {
        "order": 2,
        "name": "fullCarBenefit"
      }
    ]
  },
  {
    "name": "DeliveryDataType",
    "description": null,
    "values": [
      {
        "order": 100,
        "name": "earningsPaymentReports"
      },
      {
        "order": 101,
        "name": "employersSeparateReports"
      },
      {
        "order": 102,
        "name": "benefitsPaymentReports"
      },
      {
        "order": 103,
        "name": "recordSubscription"
      },
      {
        "order": 104,
        "name": "messages"
      },
      {
        "order": 105,
        "name": "cancellationOfEarningsPaymentReports"
      },
      {
        "order": 106,
        "name": "cancellationOfEmployersSeparateReports"
      },
      {
        "order": 107,
        "name": "cancellationOfBenefitsPaymentReports"
      },
      {
        "order": 108,
        "name": "cancellationOfARecordSubscription"
      },
      {
        "order": 109,
        "name": "cancellationOfARecordContainingEarningsPaymentReports"
      },
      {
        "order": 110,
        "name": "cancellationOfARecordContainingEmployersSeparateReports"
      },
      {
        "order": 111,
        "name": "cancellationOfARecordContainingBenefitsPaymentReports"
      },
      {
        "order": 112,
        "name": "cancellationOfARecordContainingARecordSubscription"
      }
    ]
  },
  {
    "name": "EarningsPaymentReportStatus",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "new"
      },
      {
        "order": 1,
        "name": "scheduled"
      },
      {
        "order": 2,
        "name": "succeeded"
      },
      {
        "order": 3,
        "name": "canceled"
      },
      {
        "order": 4,
        "name": "error"
      },
      {
        "order": 5,
        "name": "invalid"
      }
    ]
  },
  {
    "name": "EmploymentCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "fullTime"
      },
      {
        "order": 2,
        "name": "partTime"
      },
      {
        "order": 3,
        "name": "notAvailable"
      }
    ]
  },
  {
    "name": "EmploymentEndingCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "employeesResignation"
      },
      {
        "order": 2,
        "name": "other"
      },
      {
        "order": 3,
        "name": "terminationGroundsRelatedToEmployeesPerson"
      },
      {
        "order": 4,
        "name": "financialAndProductionRelatedGrounds"
      },
      {
        "order": 5,
        "name": "jointAgreement"
      },
      {
        "order": 6,
        "name": "retirement"
      },
      {
        "order": 7,
        "name": "terminationOfaFixedTermEmployment"
      }
    ]
  },
  {
    "name": "EmploymentEndingType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "kevaCodes"
      },
      {
        "order": 2,
        "name": "bankOfFinlandCodes"
      },
      {
        "order": 3,
        "name": "incomesRegisterCodes"
      }
    ]
  },
  {
    "name": "EmploymentRegType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "kevasGroundsForRegistration"
      },
      {
        "order": 2,
        "name": "bankOfFinlandsGroundsForRegistration"
      }
    ]
  },
  {
    "name": "ExceptionCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "noObligationToSocialInsurance"
      },
      {
        "order": 2,
        "name": "noObligationToHealthInsurance"
      },
      {
        "order": 3,
        "name": "noObligationToEarningsRelatedPensionInsurance"
      },
      {
        "order": 4,
        "name": "noObligationToAccidentAndOccupationalDiseaseInsurance"
      },
      {
        "order": 5,
        "name": "noObligationToUnemploymentInsurance"
      },
      {
        "order": 6,
        "name": "notSubjectToSocialInsurance"
      },
      {
        "order": 7,
        "name": "notSubjectToEarningsRelatedPensionInsurance"
      },
      {
        "order": 8,
        "name": "notSubjectToAccidentAndOccupationalDiseaseInsurance"
      },
      {
        "order": 9,
        "name": "notSubjectToUnemploymentInsurance"
      },
      {
        "order": 10,
        "name": "notSubjectToHealthInsurance"
      },
      {
        "order": 11,
        "name": "voluntaryEarningsRelatedPensionInsurance"
      }
    ]
  },
  {
    "name": "FaultyControl",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "onlyInvalidItems"
      },
      {
        "order": 2,
        "name": "entireRecordIsRejected"
      }
    ]
  },
  {
    "name": "Gender",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "male"
      },
      {
        "order": 2,
        "name": "female"
      }
    ]
  },
  {
    "name": "IdType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "businessId"
      },
      {
        "order": 2,
        "name": "personalIdentificationNumber"
      },
      {
        "order": 3,
        "name": "vat"
      },
      {
        "order": 4,
        "name": "giin"
      },
      {
        "order": 5,
        "name": "taxIdentificationNumber"
      },
      {
        "order": 6,
        "name": "finnishTradeRegistrationNumber"
      },
      {
        "order": 7,
        "name": "foreignBusinessRegistrationNumber"
      },
      {
        "order": 9,
        "name": "foreignPersonalIdentificationNumber"
      },
      {
        "order": 99,
        "name": "other"
      }
    ]
  },
  {
    "name": "IncomeEarnerType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "employedByStateEmploymentFund"
      },
      {
        "order": 2,
        "name": "jointOwnerWithPayer"
      },
      {
        "order": 3,
        "name": "partialOwner"
      },
      {
        "order": 4,
        "name": "keyEmployee"
      },
      {
        "order": 5,
        "name": "leasedEmployeeLivingAbroad"
      },
      {
        "order": 6,
        "name": "personWorkingInFrontierDistrict"
      },
      {
        "order": 7,
        "name": "personWorkingAbroad"
      },
      {
        "order": 8,
        "name": "athlete"
      },
      {
        "order": 9,
        "name": "performingArtist"
      },
      {
        "order": 10,
        "name": "restrictedPeriodInFinland"
      },
      {
        "order": 11,
        "name": "netOfTaxContract"
      },
      {
        "order": 12,
        "name": "organization"
      },
      {
        "order": 13,
        "name": "personWorkingOnAlandFerry"
      },
      {
        "order": 14,
        "name": "entrepreneurOrFarmerNoPensionRequired"
      },
      {
        "order": 15,
        "name": "dimplomaticMission"
      },
      {
        "order": 16,
        "name": "eppo"
      },
      {
        "order": 17,
        "name": "lightEntrepreneur"
      }
    ]
  },
  {
    "name": "InsuranceCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "subjectToSocialInsuranceContributions"
      },
      {
        "order": 2,
        "name": "subjectToEarningsRelatedPensionInsuranceContribution"
      },
      {
        "order": 3,
        "name": "subjectToHealthInsuranceContribution"
      },
      {
        "order": 5,
        "name": "subjectToUnemploymentInsuranceContribution"
      },
      {
        "order": 6,
        "name": "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution"
      }
    ]
  },
  {
    "name": "IrScheduleAction",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "send"
      },
      {
        "order": 2,
        "name": "cancel"
      }
    ]
  },
  {
    "name": "Language",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "fi"
      },
      {
        "order": 2,
        "name": "sv"
      },
      {
        "order": 3,
        "name": "en"
      }
    ]
  },
  {
    "name": "PaidAbsenceCauseCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "illness"
      },
      {
        "order": 2,
        "name": "partTimeSickLeave"
      },
      {
        "order": 3,
        "name": "parentalLeave"
      },
      {
        "order": 4,
        "name": "specialMaternityLeave"
      },
      {
        "order": 5,
        "name": "rehabilitation"
      },
      {
        "order": 6,
        "name": "childIllness"
      },
      {
        "order": 7,
        "name": "partTimeChildCareLeave"
      },
      {
        "order": 8,
        "name": "training"
      },
      {
        "order": 13,
        "name": "leaveOfAbsence"
      },
      {
        "order": 14,
        "name": "militaryRefresherTraining"
      },
      {
        "order": 18,
        "name": "midWeekHoliday"
      },
      {
        "order": 19,
        "name": "accruedHoliday"
      },
      {
        "order": 20,
        "name": "occupationalAccident"
      },
      {
        "order": 21,
        "name": "annualLeave"
      },
      {
        "order": 22,
        "name": "partTimeAbsenceDueToRehabilitation"
      },
      {
        "order": 99,
        "name": "other"
      }
    ]
  },
  {
    "name": "PayerSubOrgType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "kevasSubmitterCodes"
      },
      {
        "order": 2,
        "name": "payersOwnCodes"
      },
      {
        "order": 3,
        "name": "governmentAgencyIdentifier"
      }
    ]
  },
  {
    "name": "PayerSummaryReportStatus",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "new"
      },
      {
        "order": 1,
        "name": "scheduled"
      },
      {
        "order": 2,
        "name": "succeeded"
      },
      {
        "order": 3,
        "name": "canceled"
      },
      {
        "order": 4,
        "name": "error"
      },
      {
        "order": 5,
        "name": "invalid"
      }
    ]
  },
  {
    "name": "PayerType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "publicSector"
      },
      {
        "order": 2,
        "name": "household"
      },
      {
        "order": 3,
        "name": "temporaryEmployer"
      },
      {
        "order": 4,
        "name": "foreignEmployer"
      },
      {
        "order": 6,
        "name": "state"
      },
      {
        "order": 7,
        "name": "unincorporatedStateEnterpriseOrGovernmentalInstitution"
      },
      {
        "order": 8,
        "name": "specialisedAgency"
      },
      {
        "order": 9,
        "name": "foreignGroupCompany"
      },
      {
        "order": 10,
        "name": "poolOfHouseholdEmployers"
      }
    ]
  },
  {
    "name": "PaymentType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "monthly"
      },
      {
        "order": 2,
        "name": "hourly"
      },
      {
        "order": 3,
        "name": "contractPay"
      }
    ]
  },
  {
    "name": "PensionActCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "employeesEarningsRelatedPensionInsurance"
      },
      {
        "order": 2,
        "name": "pensionInsuranceForFarmers"
      },
      {
        "order": 3,
        "name": "pensionInsuranceForTheSelfEmployed"
      }
    ]
  },
  {
    "name": "PensionProvIdCode",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "none"
      },
      {
        "order": 10,
        "name": "finnishCentreForPensions"
      },
      {
        "order": 16,
        "name": "clergyOfTheOrthodoxChurch"
      },
      {
        "order": 20,
        "name": "kevaMemberOrganisations"
      },
      {
        "order": 24,
        "name": "kevaÅlandLandskapsregeringsPensionssystem"
      },
      {
        "order": 25,
        "name": "kevaChurch"
      },
      {
        "order": 27,
        "name": "bankOfFinland"
      },
      {
        "order": 29,
        "name": "kevaKelaEmploymentPensions"
      },
      {
        "order": 30,
        "name": "kevaState"
      },
      {
        "order": 34,
        "name": "seafarers"
      },
      {
        "order": 35,
        "name": "farmers"
      },
      {
        "order": 40,
        "name": "alandia"
      },
      {
        "order": 46,
        "name": "ilmarinen"
      },
      {
        "order": 54,
        "name": "elo"
      },
      {
        "order": 55,
        "name": "varma"
      },
      {
        "order": 56,
        "name": "veritas"
      },
      {
        "order": 90,
        "name": "etera"
      },
      {
        "order": 70014,
        "name": "uPM"
      },
      {
        "order": 70047,
        "name": "sanoma"
      },
      {
        "order": 70072,
        "name": "sandvik"
      },
      {
        "order": 70076,
        "name": "kontino"
      },
      {
        "order": 70078,
        "name": "yleisradio"
      },
      {
        "order": 70088,
        "name": "aBB"
      },
      {
        "order": 70093,
        "name": "lFashionGroup"
      },
      {
        "order": 70109,
        "name": "honeywell"
      },
      {
        "order": 70199,
        "name": "telia"
      },
      {
        "order": 70200,
        "name": "yaraSuomi"
      },
      {
        "order": 70202,
        "name": "orion"
      },
      {
        "order": 80001,
        "name": "valio"
      },
      {
        "order": 80005,
        "name": "oP"
      },
      {
        "order": 80008,
        "name": "verso"
      },
      {
        "order": 80009,
        "name": "apteekkien"
      },
      {
        "order": 80012,
        "name": "viabek"
      },
      {
        "order": 80014,
        "name": "reka"
      }
    ]
  },
  {
    "name": "ProfessionType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "statisticsFinland"
      },
      {
        "order": 2,
        "name": "keva"
      },
      {
        "order": 3,
        "name": "bankOfFinland"
      },
      {
        "order": 4,
        "name": "trafi"
      }
    ]
  },
  {
    "name": "RefPaymentType",
    "description": null,
    "values": [
      {
        "order": 2,
        "name": "earningsRelatedPensionProvider"
      }
    ]
  },
  {
    "name": "ReimbPaymentType",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "kelaDailyAllowanceApplication"
      },
      {
        "order": 2,
        "name": "kelaFamilyLeaveCompensation"
      }
    ]
  },
  {
    "name": "RemunerationCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "dailyAllowance"
      },
      {
        "order": 2,
        "name": "accommodationBenefit"
      },
      {
        "order": 3,
        "name": "carBenefit"
      },
      {
        "order": 4,
        "name": "otherBenefit"
      }
    ]
  },
  {
    "name": "ReportLogEventType",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "undefined"
      },
      {
        "order": 1,
        "name": "sent"
      },
      {
        "order": 2,
        "name": "canceled"
      },
      {
        "order": 3,
        "name": "error"
      }
    ]
  },
  {
    "name": "ResponsibilityCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "contentIssues"
      },
      {
        "order": 2,
        "name": "technicalIssues"
      }
    ]
  },
  {
    "name": "SummaryTransactionCode",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "undefined"
      },
      {
        "order": 101,
        "name": "noWagesPayable"
      },
      {
        "order": 102,
        "name": "employersHealthInsuranceContribution"
      },
      {
        "order": 103,
        "name": "deductionsToBeMadeFromTheEmployersHealthInsuranceContribution"
      }
    ]
  },
  {
    "name": "TermCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "untilFurtherNotice"
      },
      {
        "order": 2,
        "name": "fixedTerm"
      }
    ]
  },
  {
    "name": "TransactionCode",
    "description": null,
    "values": [
      {
        "order": 0,
        "name": "unknown"
      },
      {
        "order": 1,
        "name": "ignored"
      },
      {
        "order": 201,
        "name": "timeRatePay"
      },
      {
        "order": 202,
        "name": "initiativeFee"
      },
      {
        "order": 203,
        "name": "bonusPay"
      },
      {
        "order": 204,
        "name": "complementaryWagePaidDuringBenefitPeriod"
      },
      {
        "order": 205,
        "name": "emergencyWorkCompensation"
      },
      {
        "order": 206,
        "name": "eveningWorkCompensation"
      },
      {
        "order": 207,
        "name": "eveningShiftAllowance"
      },
      {
        "order": 208,
        "name": "noticePeriodCompensation"
      },
      {
        "order": 209,
        "name": "kilometreAllowanceTaxable"
      },
      {
        "order": 210,
        "name": "meetingFee"
      },
      {
        "order": 211,
        "name": "saturdayPay"
      },
      {
        "order": 212,
        "name": "extraWorkPremium"
      },
      {
        "order": 213,
        "name": "holidayBonus"
      },
      {
        "order": 214,
        "name": "lectureFee"
      },
      {
        "order": 215,
        "name": "compensationForTrustPosition"
      },
      {
        "order": 216,
        "name": "otherCompensation"
      },
      {
        "order": 217,
        "name": "waitingTimeCompensation"
      },
      {
        "order": 218,
        "name": "workingConditionCompensation"
      },
      {
        "order": 219,
        "name": "partialPayDuringSickLeave"
      },
      {
        "order": 220,
        "name": "commission"
      },
      {
        "order": 221,
        "name": "sundayWorkCompensation"
      },
      {
        "order": 222,
        "name": "benefitArisingFromSyntheticOption"
      },
      {
        "order": 223,
        "name": "performanceBonus"
      },
      {
        "order": 224,
        "name": "monetaryCompensationFromWorkingTimeBank"
      },
      {
        "order": 225,
        "name": "compensationForAccruedTimeOff"
      },
      {
        "order": 226,
        "name": "shareIssueForEmployees"
      },
      {
        "order": 227,
        "name": "contractPay"
      },
      {
        "order": 229,
        "name": "damagesInConjunctionWithTermination"
      },
      {
        "order": 230,
        "name": "standByCompensation"
      },
      {
        "order": 231,
        "name": "voluntaryCompensationInConjunctionWithTermination"
      },
      {
        "order": 232,
        "name": "weeklyRestCompensation"
      },
      {
        "order": 233,
        "name": "profitSharingBonus"
      },
      {
        "order": 234,
        "name": "annualHolidayCompensation"
      },
      {
        "order": 235,
        "name": "overtimeCompensation"
      },
      {
        "order": 236,
        "name": "nightWorkAllowance"
      },
      {
        "order": 237,
        "name": "nightShiftCompensation"
      },
      {
        "order": 238,
        "name": "otherRegularCompensation"
      },
      {
        "order": 239,
        "name": "compensationForUnusedCompensatoryLeave"
      },
      {
        "order": 301,
        "name": "accommodationBenefit"
      },
      {
        "order": 302,
        "name": "interestBenefitForHousingLoan"
      },
      {
        "order": 303,
        "name": "mealAllowance"
      },
      {
        "order": 304,
        "name": "carBenefit"
      },
      {
        "order": 308,
        "name": "compensationForGoverningBodyMembership"
      },
      {
        "order": 309,
        "name": "shareOfReserveDrawnFromPersonnelFund"
      },
      {
        "order": 310,
        "name": "monetaryGiftForEmployees"
      },
      {
        "order": 311,
        "name": "kilometreAllowanceTaxExempt"
      },
      {
        "order": 312,
        "name": "treatmentFeeForMunicipalVeterinarian"
      },
      {
        "order": 313,
        "name": "compensationForUseEarnedIncome"
      },
      {
        "order": 314,
        "name": "compensationForUseCapitalIncome"
      },
      {
        "order": 315,
        "name": "otherTaxableBenefitForEmployees"
      },
      {
        "order": 316,
        "name": "otherTaxableIncomeDeemedEarnedIncome"
      },
      {
        "order": 317,
        "name": "otherFringeBenefit"
      },
      {
        "order": 319,
        "name": "kinshipCarersFee"
      },
      {
        "order": 320,
        "name": "stockOptions"
      },
      {
        "order": 321,
        "name": "wagesPaidBySubstitutePayerIncludingSocialInsurance"
      },
      {
        "order": 322,
        "name": "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance"
      },
      {
        "order": 323,
        "name": "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance"
      },
      {
        "order": 324,
        "name": "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance"
      },
      {
        "order": 325,
        "name": "wagesPaidBySubstitutePayerIncludingHealthInsurance"
      },
      {
        "order": 326,
        "name": "compensationForEmployeeInvention"
      },
      {
        "order": 327,
        "name": "reimbursementOfPrivateCaretakersExpenses"
      },
      {
        "order": 328,
        "name": "privateCaretakersFee"
      },
      {
        "order": 329,
        "name": "reimbursementOfFamilyDayCareProvidersExpenses"
      },
      {
        "order": 330,
        "name": "telephoneBenefit"
      },
      {
        "order": 331,
        "name": "dailyAllowance"
      },
      {
        "order": 332,
        "name": "capitalIncomePayment"
      },
      {
        "order": 334,
        "name": "mealBenefit"
      },
      {
        "order": 335,
        "name": "reimbursementOfCostsPaidToConciliator"
      },
      {
        "order": 336,
        "name": "nonWageCompensationForWork"
      },
      {
        "order": 337,
        "name": "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund"
      },
      {
        "order": 338,
        "name": "pensionPaidByEmployer"
      },
      {
        "order": 339,
        "name": "dividendsBasedOnWages"
      },
      {
        "order": 340,
        "name": "dividendsBasedOnNonWage"
      },
      {
        "order": 341,
        "name": "employerSubsidisedCommuterTicketTaxExempt"
      },
      {
        "order": 342,
        "name": "employerSubsidisedCommuterTicketTaxable"
      },
      {
        "order": 343,
        "name": "employeeStockOption"
      },
      {
        "order": 350,
        "name": "wagesTransferredToAthletesSpecialFund"
      },
      {
        "order": 351,
        "name": "wagesPaidFromAthletesSpecialFund"
      },
      {
        "order": 352,
        "name": "wagesForInsurancePurposes"
      },
      {
        "order": 353,
        "name": "taxableReimbursementOfExpenses"
      },
      {
        "order": 354,
        "name": "privateDayCareAllowanceMunicipalSupplement"
      },
      {
        "order": 355,
        "name": "privateDayCareAllowanceWages"
      },
      {
        "order": 356,
        "name": "privateDayCareAllowanceNonWage"
      },
      {
        "order": 357,
        "name": "kilometreAllowancePaidByNonProfitOrganisation"
      },
      {
        "order": 358,
        "name": "dailyAllowancePaidByNonProfitOrganisation"
      },
      {
        "order": 359,
        "name": "unjustEnrichment"
      },
      {
        "order": 361,
        "name": "employeeStockOptionLowerMarketPrice"
      },
      {
        "order": 362,
        "name": "royaltyPaidToNonResidentTaxpayer"
      },
      {
        "order": 363,
        "name": "bicycleBenefitTaxExempt"
      },
      {
        "order": 364,
        "name": "bicycleBenefitTaxable"
      },
      {
        "order": 365,
        "name": "conditionalStockOptions"
      },
      {
        "order": 366,
        "name": "copyrightRoyaltiesEarnedIncome"
      },
      {
        "order": 367,
        "name": "stockGrantPaidInMoney"
      },
      {
        "order": 368,
        "name": "employeeStockOptionPaidInMoney"
      },
      {
        "order": 369,
        "name": "earningsFromJuELEmployerToLightEntrepreneur"
      },
      {
        "order": 401,
        "name": "compensationCollectedForCarBenefit"
      },
      {
        "order": 402,
        "name": "withholdingTax"
      },
      {
        "order": 403,
        "name": "electedOfficialFee"
      },
      {
        "order": 404,
        "name": "taxAtSource"
      },
      {
        "order": 405,
        "name": "taxAtSourceDeduction"
      },
      {
        "order": 406,
        "name": "wagesPaid"
      },
      {
        "order": 407,
        "name": "reimbursementCollectedForOtherFringeBenefits"
      },
      {
        "order": 408,
        "name": "otherItemDeductibleFromNetWage"
      },
      {
        "order": 409,
        "name": "netWage"
      },
      {
        "order": 410,
        "name": "employerPaidPremiumForCollectiveAdditionalPensionInsurance"
      },
      {
        "order": 411,
        "name": "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution"
      },
      {
        "order": 412,
        "name": "employeesHealthInsuranceContribution"
      },
      {
        "order": 413,
        "name": "employeesPensionInsuranceContribution"
      },
      {
        "order": 414,
        "name": "employeesUnemploymentInsuranceContribution"
      },
      {
        "order": 415,
        "name": "reimbursementForEmployerSubsidisedCommuterTicket"
      },
      {
        "order": 416,
        "name": "taxPaidAbroad"
      },
      {
        "order": 417,
        "name": "distraint"
      },
      {
        "order": 418,
        "name": "voluntaryIndividualPensionInsurancePremium"
      },
      {
        "order": 419,
        "name": "deductionBeforeWithholding"
      },
      {
        "order": 420,
        "name": "reimbursementCollectedForBicycleBenefit"
      }
    ]
  },
  {
    "name": "UnpaidAbsenceCauseCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "illness"
      },
      {
        "order": 2,
        "name": "partTimeSickLeave"
      },
      {
        "order": 3,
        "name": "parentalLeave"
      },
      {
        "order": 4,
        "name": "specialMaternityLeave"
      },
      {
        "order": 5,
        "name": "rehabilitation"
      },
      {
        "order": 6,
        "name": "childIllness"
      },
      {
        "order": 7,
        "name": "partTimeChildCareLeave"
      },
      {
        "order": 8,
        "name": "training"
      },
      {
        "order": 9,
        "name": "jobAlternationLeave"
      },
      {
        "order": 10,
        "name": "studyLeave"
      },
      {
        "order": 11,
        "name": "industrialAction"
      },
      {
        "order": 12,
        "name": "interruptionInWorkProvision"
      },
      {
        "order": 13,
        "name": "leaveOfAbsence"
      },
      {
        "order": 14,
        "name": "militaryRefresherTraining"
      },
      {
        "order": 15,
        "name": "militaryService"
      },
      {
        "order": 16,
        "name": "layOff"
      },
      {
        "order": 17,
        "name": "childCareLeave"
      },
      {
        "order": 99,
        "name": "other"
      }
    ]
  },
  {
    "name": "WageUnitCode",
    "description": null,
    "values": [
      {
        "order": 1,
        "name": "hour"
      },
      {
        "order": 2,
        "name": "day"
      },
      {
        "order": 3,
        "name": "week"
      },
      {
        "order": 5,
        "name": "period"
      }
    ]
  }
];
